import styles from "./candidateFlow.module.scss";
import { AGENT_FLOW_STEPS } from "../../utils/constants";

type FlowContainerProps = {
  agentId?: string;
};

const FlowContainer = ({ agentId }: FlowContainerProps) => {
  // Get steps for the specific agent ID, return null if not defined
  if (!agentId || !AGENT_FLOW_STEPS[agentId]) {
    return null;
  }

  const stepsData = AGENT_FLOW_STEPS[agentId];

  // Define gradient backgrounds for each step position
  const getGradientClass = (index: number) => {
    const gradients = [
      styles.gradient1, // Deep indigo/dark blue to lighter blue/periwinkle
      styles.gradient2, // Teal/turquoise to lighter cyan/aqua
      styles.gradient3, // Vibrant purple to lighter pink/lavender
      styles.gradient4, // Bright red to lighter coral/pinkish-orange
      styles.gradient5, // Medium green to lighter, brighter green
    ];
    return gradients[index % gradients.length];
  };

  return (
    <div className={styles.candidateFlow}>
      {stepsData.map((step, index) => {
        const isLast = index === stepsData.length - 1;

        return (
          <div key={step.id} className={styles.flowRow}>
            <div className={`${styles.flowBox} ${getGradientClass(index)}`}>
              <p className={styles.flowText}>{step.text}</p>
            </div>

            {!isLast && (
              <div className={styles.triangle}></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FlowContainer;
